import React from 'react';
import { Home, UtensilsCrossed, TreePine, Heart } from 'lucide-react';
import { Button } from './ui/button';
import { features } from '../data/mockData';

const featureIcons = [Home, UtensilsCrossed, TreePine, Heart];
const featureColors = ['#5DADE2', '#F39C12', '#52BE80', '#FF6347'];

const AboutSection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Top section with Wij and intro */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Left side - Large "Wij" text */}
          <div className="relative">
            <h2
              className="text-[180px] md:text-[250px] font-bold text-[#1A4D4D] leading-none opacity-10 select-none"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Wij
            </h2>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
              <img
                src="https://customer-assets.emergentagent.com/job_youth-care-hub-1/artifacts/7x7q2891_3982ab8c-ed41-46b3-8787-1ce02cc8dd1f%20%281%29.jpeg"
                alt="Dagbesteding"
                className="rounded-3xl shadow-2xl w-full object-cover"
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div>
            <h3
              className="text-4xl md:text-5xl font-bold text-[#1A4D4D] mb-6 leading-tight"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Passie voor (jeugd)zorg
            </h3>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Wij zijn betrokken zorgverleners met ruime ervaring in de gehandicaptenzorg. Als (kinder)verpleegkundige bied ik professionele zorg met het hart op de juiste plek. Onze kracht ligt in kleinschaligheid (1-op-1), een huiselijke aanpak en persoonlijke aandacht.
            </p>
            <a href="mailto:info@kscare.nl?subject=Kennismaking%20KS%20Care">
              <Button className="bg-[#FF6347] hover:bg-[#FF5533] text-white rounded-full px-8 py-6 text-lg transition-all duration-300 hover:shadow-xl">
                Maak kennis
              </Button>
            </a>
          </div>
        </div>

        {/* Wat bieden wij - Features grid */}
        <div className="mt-16">
          <div className="text-center mb-12">
            <h3 className="text-xl md:text-2xl text-gray-600 mb-2" style={{ fontFamily: 'Quicksand, sans-serif' }}>
              Wat bieden wij
            </h3>
            <h2
              className="text-4xl md:text-5xl font-bold text-[#1A4D4D]"
              style={{ fontFamily: 'Fredoka, Quicksand, sans-serif' }}
            >
              Onze zorg in de praktijk
            </h2>
          </div>

          {/* Features grid - 2x2 on desktop, 1 column on mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const IconComponent = featureIcons[index];
              const color = featureColors[index];
              return (
                <div
                  key={feature.id}
                  className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="flex items-start gap-4">
                    <div
                      className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: `${color}20` }}
                    >
                      <IconComponent className="w-7 h-7" style={{ color: color }} />
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-[#1A4D4D] mb-2">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Decorative tree illustration */}
      <div className="absolute top-10 right-10 opacity-20 hidden xl:block">
        <svg width="100" height="150" viewBox="0 0 100 150" fill="none">
          <circle cx="50" cy="40" r="35" fill="#52BE80" />
          <circle cx="30" cy="60" r="25" fill="#52BE80" />
          <circle cx="70" cy="55" r="28" fill="#52BE80" />
          <rect x="45" y="80" width="10" height="70" fill="#A0826D" />
        </svg>
      </div>
    </section>
  );
};

export default AboutSection;
